import { render, staticRenderFns } from "./BlockMultiFields.vue?vue&type=template&id=3ee32fea&scoped=true&"
import script from "./BlockMultiFields.vue?vue&type=script&lang=ts&"
export * from "./BlockMultiFields.vue?vue&type=script&lang=ts&"
import style0 from "./BlockMultiFields.vue?vue&type=style&index=0&id=3ee32fea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee32fea",
  null
  
)

export default component.exports